// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11sYZ","select":"styles_select__2-fdY"};